import Button from "comps/Button"
import useRateAndSellCount from "hooks/useRateAndSellCount"
import Dian from "icons/store-icon.svg"
import router from "next/router"
import Rate from "./Rate"

export default function ProductDetailShopSection({
  shopName,
  shopSysNo,
  score,
}: {
  shopName: string
  shopSysNo: string
  score: number | string
}) {
  const { canView } = useRateAndSellCount()
  if (!shopSysNo) return null
  return (
    <>
      <div className="shopSection">
        <div className="shopName">
          <Dian />
          {shopName}
        </div>
        {canView && score && (
          <div className="rate-wrap">
            <Rate value={+score} size={14} scoreSize={16} scoreGutter={8} />
          </div>
        )}
        <div>
          <Button
            text="进店逛逛"
            type="secondary"
            onClick={() => {
              router.push(`/shop/index/${shopSysNo}`)
            }}
          />
        </div>
      </div>
      <style jsx>{`
        .shopSection {
          margin: 10px 0;
          padding: 24px 0;
          background-image: linear-gradient(180deg, #f5f8ff 0%, #ffffff 100%);
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .shopName {
          font-size: 16px;
          color: #333333;
          letter-spacing: 0;
          font-weight: bolder;
          margin-bottom: 18px;
          line-height: 1;
        }

        .shopName :global(svg) {
          display: inline-block;
          vertical-align: bottom;
          margin-right: 6px;
        }

        .rate-wrap {
          margin-bottom: 16px;
        }
      `}</style>
    </>
  )
}
